import React, { Fragment, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { HiOutlineSearch, HiShoppingCart, HiUserAdd, HiOutlineHeart } from 'react-icons/hi'
import { useSelector } from 'react-redux';
import { useState } from 'react';
import cogoToast from 'cogo-toast'
import { productListApi } from '../../apis/productApi';
import { getUserDetails, removeSessions } from '../../helper/sessionHelper';
import { useRef } from 'react';

const Header = () => {
    const [searchText, setSearchText] = useState("");
    const [toggleMenu, setToggleMenu] = useState(false);
    const ref = useRef(null)
    // const [isTrue,setIsTrue] = useState(false)
    const cartData = useSelector(state => state.cart.cartList);
    const navigate = useNavigate();
    const user = getUserDetails();

    const handleSearch = () => {
        if (searchText === "") {
            cogoToast.error("Please enter search keyword", {
                position: "bottom-center"
            })
            // setIsTrue(true)
        } else {
            productListApi(1, 5, searchText);
            setSearchText("")
            // setIsTrue(false)
            navigate(`/search-all/${searchText}`)
        }
    }

    const toggleProfile = () => {
        setToggleMenu(!toggleMenu)
    }
    const closeMenu = () => {
        setToggleMenu(false)
    }

    // click outside menu handler 
    useEffect(() => {
        const handler = (event) => {
            if (!ref.current.contains(event.target)) {
                setToggleMenu(false)
            }
        }
        document.addEventListener("mousedown", handler)

        return () => {
            document.removeEventListener("mousedown", handler)
        }
    })

    const logOut = () => {
        removeSessions()
        navigate('/')
    }

    return (
        <Fragment>
            <div ref={ref} className="shadow">
                <div className="container mx-auto px-5 lg:px-0">
                    <div className="grid grid-cols-4 lg:grid-cols-6 gap-4 items-center py-4">
                        <div className="logo">
                            <Link to="/">
                                <h4 className='text-xl font-semibold text-gray-600'> <span className='text-3xl text-blue-400'>B</span>akiz</h4>
                            </Link>
                        </div>
                        <div className='lg:col-span-4 col-span-2'>
                            <div className="search-bar flex justify-center">
                                <input onChange={(e) => setSearchText(e.target.value)} className={` bg-gray-100 w-[150px] lg:w-2/3 h-12 pl-5 focus:outline-regal-blue lg:text-[16px] text-[12px]`} value={searchText} type="text" placeholder='Search for product' />
                                <button onClick={handleSearch} className='flex items-center bg-regal-blue px-3 text-xl text-white'><HiOutlineSearch /></button>
                            </div>
                        </div>
                        <div className="cart-login flex items-center justify-end space-x-2 lg:space-x-4">
                            <Link className='hidden lg:block' to="/wishlist">
                                <span className='flex items-center relative cursor-pointer font-semibold text-regal-blue'><HiOutlineHeart className='text-2xl' /><span className='absolute -top-3 text-[12px] -right-2 bg-gray-500 text-white rounded-full inline-block w-5 h-5 text-center leading-5'>0</span></span>
                            </Link>
                            <Link to="/cart">
                                <span className='flex items-center relative cursor-pointer font-semibold text-regal-blue'><HiShoppingCart className='text-2xl' /><span className='absolute -top-3 text-[12px] -right-3 bg-gray-500 text-white rounded-full inline-block w-5 h-5 text-center leading-5'>{cartData?.length > 0 ? `${cartData.length}` : 0}</span></span>
                            </Link>
                            {user !== null ? <div onClick={toggleProfile}>
                                <img className='w-8 cursor-pointer' src={user?.photo} alt={user?.firstName} />
                            </div> : <Link to="/login">
                                <button className='text-gray-500 font-semibold flex items-center'><HiUserAdd className='text-2xl text-regal-blue' /></button>
                            </Link>}
                            {
                                toggleMenu && <div className='mt-3 w-[250px] absolute top-14 bg-white border-[1px] shadow-lg rounded z-50'>
                                    <div className="user-info text-center py-3">
                                        <img className='w-14 mx-auto' src={user?.photo} alt={user?.firstName} />
                                        <h4 className='font-semibold mt-2 mb-1'>{user?.firstName}</h4>
                                        <Link to='/manage-profile'><button onClick={closeMenu} className='bg-regal-blue px-2 py-1 text-white rounded'>View Profile</button></Link>
                                        <div className='mt-2 bg-gray-300 w-full h-[1px]'></div>
                                    </div>
                                    <div>
                                        <Link onClick={closeMenu} className='block px-5 hover:text-regal-blue border-l-[5px] font-semibold border-transparent hover:border-regal-blue transition-all duration-200 text-gray-600' to="/manage-profile">
                                            Manage My Account
                                        </Link>
                                        <Link onClick={closeMenu} className='block px-5 mt-1 hover:text-regal-blue border-l-[5px] font-semibold border-transparent hover:border-regal-blue transition-all duration-200 text-gray-600' to="/my-order">
                                            My Orders
                                        </Link>
                                        <Link onClick={closeMenu} className='block px-5 mt-1 hover:text-regal-blue border-l-[5px] font-semibold border-transparent hover:border-regal-blue transition-all duration-200 text-gray-600' to="/wishlist">
                                            My Wishlist
                                        </Link>
                                        <button onClick={logOut} className='block px-5 mt-1 hover:text-regal-blue border-l-[5px] font-semibold border-transparent hover:border-regal-blue transition-all duration-200 text-gray-600' to='/'>
                                            Log Out
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    {/* bottom nav  */}
                    <div className="grid grid-cols-6 gap-4 items-center pb-3">
                        <div className="col-span-4 col-start-2 text-center">
                            {/* <NavLink className={(navData)=>navData.isActive ? "font-semibold text-regal-blue mr-10" : "mr-10 hover:text-regal-blue text-gray-500 font-semibold transition-all duration-300"} to="/">Home</NavLink> */}
                            <NavLink className={(navData) => navData.isActive ? "active" : "header-nav"} to="/">Home</NavLink>
                            <NavLink className={(navData) => navData.isActive ? "active" : "header-nav"} to="/shop">Shop</NavLink>
                            <NavLink className={(navData) => navData.isActive ? "active" : "header-nav"} to="/category/Nutrition">Nutrition</NavLink>
                            <NavLink className={(navData) => navData.isActive ? "active" : "header-nav"} to="/category/Toys">Toys</NavLink>
                            <NavLink className={(navData) => navData.isActive ? "active" : "header-nav"} to="/category/Fashion">Baby Fashion</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Header;